// src/Shared/BlockUIService.js

export default (function () {
    return {
        Start() {
            // prevent multiple overlays
            if (document.querySelector('.block-ui-overlay')) return;

            // Create overlay
            const overlay = document.createElement('div');
            overlay.className = 'block-ui-overlay';
            overlay.innerHTML = `
                <div class="block-ui-spinner text-center">
                    <br />
                    <div class="spinner-grow text-light" style="width: 3rem; height: 3rem" role="status">
                        <span class="visually-hidden">Loading...</span>
                    </div>
                </div>
            `;

            // Overlay styles
            overlay.style.position = 'fixed';
            overlay.style.top = '0';
            overlay.style.left = '0';
            overlay.style.width = '100%';
            overlay.style.height = '100%';
            overlay.style.backgroundColor = 'rgba(0, 0, 0, 0.6)';
            overlay.style.zIndex = '9999';
            overlay.style.display = 'flex';
            overlay.style.alignItems = 'center';
            overlay.style.justifyContent = 'center';

            // Append to body
            document.body.appendChild(overlay);
        },

        Stop() {
            const overlay = document.querySelector('.block-ui-overlay');
            if (overlay) {
                overlay.remove();
            }
        }
    };
})();
